import React from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export function Reveal({
  children,
  className = '',
  delay = 0
}: RevealProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 28
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.55,
    ease: 'easeOut',
    delay
  }} className={className} data-id="element-178" data-mp="3fxovdaxr7hy9">
      {children}
    </motion.div>;
}
interface EyebrowProps {
  children: React.ReactNode;
}
export function Eyebrow({
  children
}: EyebrowProps) {
  return <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-coral-dark" data-id="element-179" data-mp="2p2bocnlr678">
      {children}
    </span>;
}